import { render, staticRenderFns } from "./ReserveTabs.vue?vue&type=template&id=4f341d99&scoped=true"
import script from "./ReserveTabs.vue?vue&type=script&lang=js"
export * from "./ReserveTabs.vue?vue&type=script&lang=js"
import style0 from "./ReserveTabs.vue?vue&type=style&index=0&id=4f341d99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f341d99",
  null
  
)

export default component.exports